import {
  IconDefinition,
  faAsterisk,
  faClockRotateLeft,
  faEdit,
  faEye,
  faEnvelopeCircleCheck,
  faIdCard,
  faPlay,
  faPassport,
  faUserLock,
  faSitemap,
  faSquarePlus,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { ReactElement } from 'react';
import { Tag } from '.';
import { PermissionAction } from '../types';
import classNames from '../utilities/class-names';

type TokenPermissionActionTagStyle = {
  icon: IconDefinition;
  className: string;
  label: string;
};

const tokenPermissionActionTagStyles: {
  [key in PermissionAction]: TokenPermissionActionTagStyle;
} = {
  '*': {
    icon: faAsterisk,
    className: 'token-permission-action-tag-all',
    label: 'All',
  },
  create: {
    icon: faSquarePlus,
    className: 'token-permission-action-tag-create',
    label: 'Create',
  },
  view: {
    icon: faEye,
    className: 'token-permission-action-tag-view',
    label: 'View',
  },
  update: {
    icon: faEdit,
    className: 'token-permission-action-tag-update',
    label: 'Update',
  },
  delete: {
    icon: faTrash,
    className: 'token-permission-action-tag-delete',
    label: 'Delete',
  },
  restore: {
    icon: faClockRotateLeft,
    className: 'token-permission-action-tag-restore',
    label: 'Restore',
  },
  register: {
    icon: faIdCard,
    className: 'token-permission-action-tag-register',
    label: 'Register',
  },
  authenticate: {
    icon: faPassport,
    className: 'token-permission-action-tag-authenticate',
    label: 'Authenticate',
  },
  'reset-password': {
    icon: faUserLock,
    className: 'token-permission-action-tag-reset-password',
    label: 'Reset password',
  },
  'verify-email': {
    icon: faEnvelopeCircleCheck,
    className: 'token-permission-action-tag-verify-email',
    label: 'Verify email',
  },
  'create-with-identity': {
    icon: faSquarePlus,
    className: 'token-permission-action-tag-create-with-identity',
    label: 'Create with identity',
  },
  'view-with-identity': {
    icon: faEye,
    className: 'token-permission-action-tag-view-with-identity',
    label: 'View with identity',
  },
  'update-with-identity': {
    icon: faEdit,
    className: 'token-permission-action-tag-update-with-identity',
    label: 'Update with identity',
  },
  'delete-with-identity': {
    icon: faTrash,
    className: 'token-permission-action-tag-delete-with-identity',
    label: 'Delete with identity',
  },
  'restore-with-identity': {
    icon: faClockRotateLeft,
    className: 'token-permission-action-tag-restore-with-identity',
    label: 'Restore with identity',
  },
  'sync-schema': {
    icon: faSitemap,
    className: 'token-permission-action-tag-sync-schema',
    label: 'Sync schema',
  },
  run: {
    icon: faPlay,
    className: 'token-permission-action-tag-run',
    label: 'Run',
  },
  'run-with-identity': {
    icon: faPlay,
    className: 'token-permission-action-tag-run-with-identity',
    label: 'Run with identity',
  },
};

type TokenPermissionActionTagProps = {
  action: PermissionAction;
};

export function TokenPermissionActionTag({
  action,
}: TokenPermissionActionTagProps): ReactElement {
  let { icon, className, label } = tokenPermissionActionTagStyles[action];

  return (
    <Tag
      show
      className={classNames('token-permission-action-tag', className)}
      icon={icon}
    >
      {label}
    </Tag>
  );
}
